"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const tracking_1 = __importDefault(require("./tracking"));
const Tag = ({ children, name, properties }) => {
    if (!children) {
        return null;
    }
    return (0, react_1.cloneElement)(children, Object.assign(Object.assign({}, children.props), { onClick: (e) => {
            tracking_1.default.track(name, properties);
            if (children.props && children.props.onClick) {
                children.props.onClick(e);
            }
        } }));
};
exports.default = Tag;
